import { Stack, Button } from "@mui/material";
import { FC } from "react";
import SalifySvgIconString from "../../icon/svg/svg-icon-string";
import { ActionBlock as ActionBlockType } from "../types";

interface ActionsBlockProps {
  actions: ActionBlockType;
  theme: string;
}

const ActionsBlock: FC<ActionsBlockProps> = ({ actions, theme }) => {
  const getButtonStyles = (buttonType: string) => {
    const baseStyles = {
      textTransform: "none" as const,
      borderRadius: "8px",
      fontWeight: 600,
      padding: "12px 32px",
    };

    switch (theme) {
      case "haianh":
        switch (buttonType) {
          case "primary":
            return {
              ...baseStyles,
              backgroundColor: "#FFC107",
              color: "#000",
              "&:hover": {
                backgroundColor: "#FFB300",
              },
            };
          case "secondary":
            return {
              ...baseStyles,
              backgroundColor: "transparent",
              color: "#FFC107",
              border: "2px solid #FFC107",
              "&:hover": {
                backgroundColor: "#FFC107",
                color: "#000",
              },
            };
          case "outline":
            return {
              ...baseStyles,
              backgroundColor: "transparent",
              color: "#666",
              border: "1px solid #e0e0e0",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            };
          default:
            return {
              ...baseStyles,
              backgroundColor: "transparent",
              color: "#666",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            };
        }
      case "nova-press":
        switch (buttonType) {
          case "primary":
            return {
              ...baseStyles,
              backgroundColor: "#01a750",
              color: "#fff",
              "&:hover": {
                backgroundColor: "#019145",
              },
            };
          case "secondary":
            return {
              ...baseStyles,
              backgroundColor: "transparent",
              color: "#01a750",
              border: "2px solid #01a750",
              "&:hover": {
                backgroundColor: "#01a750",
                color: "#fff",
              },
            };
          default:
            return {
              ...baseStyles,
              backgroundColor: "transparent",
              color: "#666",
              border: "1px solid #e0e0e0",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            };
        }
      default:
        switch (buttonType) {
          case "primary":
            return {
              ...baseStyles,
              backgroundColor: "#1976d2",
              color: "#fff",
              "&:hover": {
                backgroundColor: "#1565c0",
              },
            };
          case "secondary":
            return {
              ...baseStyles,
              backgroundColor: "transparent",
              color: "#1976d2",
              border: "2px solid #1976d2",
              "&:hover": {
                backgroundColor: "#1976d2",
                color: "#fff",
              },
            };
          default:
            return {
              ...baseStyles,
              backgroundColor: "transparent",
              color: "#1976d2",
              border: "none",
              padding: "0",
              textDecoration: "none",
              fontWeight: 400,
              fontSize: 16,
              "&:hover": {
                backgroundColor: "transparent",
                textDecoration: "underline",
              },
            };
        }
    }
  };

  return (
    <Stack
      direction={actions.layout === "vertical" ? "column" : "row"}
      spacing={2}
      alignItems="flex-start"
      {...actions.stackProps}
    >
      {actions.buttons.map((button, index) => (
        <Button
          key={index}
          href={button.href}
          onClick={button.onClick}
          sx={{
            ...getButtonStyles(button.type),
            ...button.style,
          }}
          startIcon={
            button.icon ? <SalifySvgIconString svgString={button.icon} fontSize={16} /> : undefined
          }
        >
          {button.text}
        </Button>
      ))}
    </Stack>
  );
};

export default ActionsBlock;
